import { useNavigate } from 'react-router';

import { Button } from 'ui';

import { StandaloneTeacherSearchFilters } from './TeacherSearchFilters';
import classes from '../Teacher.module.scss';

export const TeacherSearchErrorPay = () => {
  const navigate = useNavigate();

  return (
    <>
      <main className={classes['teacher-search-error']}>
        <h1>Подсказка:</h1>
        <p>Чтобы открыть заказы, нужна комиссия 1000 руб.</p>
        <div>
          <Button
            onClick={() => navigate('/teacher/search')}
            variant={'filled'}
            size={'md'}
            shape={'brick'}
            color={'primary'}
          >
            Продолжить
          </Button>
        </div>
      </main>
      <StandaloneTeacherSearchFilters />
    </>
  );
};
